import i18n from '@/plugins/i18n';

/**
 * ตัวช่วยแสดงผลเรื่องแพ็ก / อายุการใช้งาน — ใช้ร่วมกันที่เมนูผู้ใช้ · หน้าตั้งค่า · แถบเตือน · popup · หน้าล็อก
 * เรียกตอน render (ในเทมเพลต/computed) → เปลี่ยนภาษาแล้วอัปเดตเอง
 */

// 'YYYY-MM-DD' → Date เที่ยงคืนเวลาเครื่อง (ไม่ใช่ UTC) กันวันเลื่อนไปหนึ่งวัน
export const parseLicenseDay = (iso) => new Date(`${iso}T00:00:00`);

/** '2026-10-31' → '31 ต.ค. 2569' / '31 Oct 2026' · ค่าว่าง = '' */
export function formatLicenseDate(iso) {
  if (!iso) return '';
  const locale = i18n.global.locale === 'th' ? 'th-TH' : 'en-GB';
  return new Intl.DateTimeFormat(locale, { day: 'numeric', month: 'short', year: 'numeric' }).format(parseLicenseDay(iso));
}

/**
 * ชื่อแพ็กตามภาษา — API ส่งชื่ออังกฤษมา (Starter / Standard / Professional / Trial) FE แปลเองที่ _plan.<ชื่อ>
 * แพ็กใหม่ที่ยังไม่มีคำแปล = โชว์ชื่ออังกฤษไปก่อน (ไม่โชว์คีย์ดิบ)
 */
export function planLabel(name) {
  if (!name) return '';
  const key = `_plan.${name}`;
  return i18n.global.te(key) ? i18n.global.t(key) : name;
}
